export const menuRoles: any[] = [
  {
    role: 'ADMIN',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      {
        label: 'Site internet',
        code: 'website',
        faIcon: 'water',
        submenu: [
          {
            faIcon: 'cart-shopping',
            label: 'Paniers',
            link: ['rental', 'carts'],
          },
          {
            faIcon: 'users',
            label: 'Visiteurs moteur',
            link: ['rental', 'ea-users'],
          },
          {
            faIcon: 'robot',
            label: 'Catalogue IA',
            link: ['catalog'],
          },
          {
            faIcon: 'list-check',
            label: 'Log MCP',
            link: ['catalog', 'mcp-log'],
          },
          {
            faIcon: 'list',
            label: 'Logs Engine API (debug)',
            link: ['rental', 'be-log'],
          },

        ],
      },
      {
        label: 'Users.management.title',
        code: 'admin.users',
        faIcon: 'users',
        submenu: [
          {
            faIcon: 'user-shield',
            label: 'Users.menu.label',
            link: ['admin', 'users'],
          },
          {
            faIcon: 'user-tag',
            label: 'Agents.menu.label',
            link: ['admin', 'agents'],
          },
          {
            faIcon: 'building-user',
            label: 'Owners.menu.label',
            link: ['admin', 'owners'],
          },
          {
            faIcon: 'user-astronaut',
            label: 'ClientsWeb.menu.label',
            link: ['admin', 'clients-web'],
          },
        ],
      },
      {
        label: 'Rental.management.title',
        code: 'rental',
        faIcon: 'ship',
        submenu: [
          {
            faIcon: 'envelope',
            label: 'Messages',
            link: ['rental', 'messages'],
          },
          {
            faIcon: 'calendar',
            label: 'Rental.planning.title',
            link: ['rental', 'planning'],
          },
          {
            faIcon: 'handshake-simple',
            label: 'Rental.bookingsAndOptions.label',
            link: ['rental', 'bookings'],
          },
          {
            faIcon: 'user',
            label: 'Clients',
            link: ['rental', 'clients'],
          },
          {
            faIcon: 'calendar-day',
            label: 'Wanday planning',
            link: ['rental', 'wanday-planning'],
          },
          {
            faIcon: 'hand-paper',
            label: 'Rental.quotes.label',
            link: ['rental', 'quotes'],
          },
          {
            faIcon: 'cloud-download-alt',
            label: 'Demandes de devis',
            link: ['rental', 'quote-requests'],
          },
          {
            faIcon: 'tags',
            label: 'Remises et optimisations',
            link: ['rental', 'optimise-discount'],
          },
          {
            faIcon: 'credit-card-alt',
            label: 'Paiements',
            link: ['rental', 'payments'],
          },
        ],
      },
      {
        label: 'Ville De Digoin',
        code: 'vdd',
        faIcon: 'hotel',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'Planning',
            link: ['vdd', 'planning'],
          },
          {
            faIcon: 'handshake-simple',
            label: 'Réservations',
            link: ['vdd', 'bookings'],
          },

          {
            faIcon: 'hand-paper',
            label: 'Rental.quotes.label',
            link: ['vdd', 'quotes'],
          },
          {
            faIcon: 'ship',
            label: `Bateaux`,
            link: ['vdd', 'boats'],
          },
          {
            faIcon: 'users',
            label: `Clients`,
            link: ['vdd', 'clients'],
          },
          {
            faIcon: 'question-circle',
            label: `Type d'évènements`,
            link: ['vdd', 'trips'],
          },
          {
            faIcon: 'cube',
            label: 'Produits',
            link: ['vdd', 'items'],
          },
          {
            faIcon: 'palette',
            label: 'Catégories de produits',
            link: ['vdd', 'item-categories'],
          },
          {
            faIcon: 'tags',
            label: 'Remises',
            link: ['vdd', 'discounts'],
          },
          {
            faIcon: 'credit-card-alt',
            label: 'Paiements',
            link: ['vdd', 'payments'],
          },
          {
            faIcon: 'gift',
            label: 'Chèques cadeaux',
            link: ['vdd', 'gift-vouchers'],
          },
          {
            faIcon: 'clock-rotate-left',
            label: 'Historique',
            link: ['vdd', 'booking-history'],
          }

        ],
      },
      {
        label: 'Translations.label',
        code: 'admin.translations',
        faIcon: 'globe',
        link: ['admin', 'translations'],
      },
      {
        label: 'Données',
        code: 'admin.data',
        faIcon: 'database',
        submenu: [
          { faIcon: 'user', label: 'Clients', link: ['rental', 'client-list'] },
          {
            faIcon: 'toolbox',
            label: 'Equipements',
            link: ['rental', 'equipment-list'],
          },
          {
            faIcon: 'list',
            label: 'Caractéristiques (bateaux)',
            link: ['rental', 'feature-list'],
          },
          {
            faIcon: 'ship',
            label: 'Modèles de bateaux',
            link: ['rental', 'models'],
          },
          {
            faIcon: 'earth-europe',
            label: 'Régions',
            link: ['rental', 'zone-list'],
          },
          { faIcon: 'flag', label: 'Bases', link: ['rental', 'base-list'] },
          {
            faIcon: 'bridge-water',
            label: 'Voies navigables',
            link: ['rental', 'waterway-list'],
          },
          {
            faIcon: 'map-marked-alt',
            label: 'Itinéraires',
            link: ['rental', 'trip-list'],
          },
          {
            faIcon: 'ship',
            label: 'Liste des bateaux',
            link: ['rental', 'boat-list'],
          },
          {
            faIcon: 'hands-helping',
            label: 'Services et options (bateaux)',
            link: ['rental', 'boat-services-list'],
          },
          {
            faIcon: 'dollar-sign',
            label: 'Grilles de prix',
            link: ['rental', 'price-grids'],
          },
          {
            faIcon: 'envelope',
            label: 'Templates email',
            link: ['rental', 'email-templates'],
          },
        ],
      },
      {
        label: 'Open AI',
        code: 'admin.openai',
        faIcon: 'brain',
        submenu: [
          {
            faIcon: 'pen-to-square',
            label: 'OpenAI.free.title',
            link: ['admin', 'open-ai'],
          },
          {
            faIcon: 'hand-holding-dollar',
            label: 'OpenAI.quotes.title',
            link: ['admin', 'open-ai-quotes'],
          },
        ],
      },
      {
        label: 'Orders.management.title',
        code: 'order.orders',
        faIcon: 'clipboard-list',
        submenu: [
          {
            faIcon: 'clipboard-question',
            label: 'OrderRequests.menu.label',
            link: ['order', 'order-requests'],
          },
          {
            faIcon: 'comment-dots',
            label: 'OrderRequestsCreate.menu.label',
            link: ['order', 'order-request-create'],
          },
          {
            faIcon: 'clipboard-check',
            label: 'Orders.menu.label',
            link: ['order', 'orders'],
          },
          {
            faIcon: 'people-carry',
            label: 'Supplier.menu.label',
            link: ['order', 'suppliers'],
          },
          // {
          //   faIcon: 'shopping-cart',
          //   label: 'SmallPurchases.menu.label',
          //   link: ['order', 'small-purchases'],
          // },
          // {
          //   faIcon: 'tags',
          //   label: 'SmallPurchaseCategories.menu.label',
          //   link: ['order', 'small-purchase-categories'],
          // },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          // { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
        ],
      },
      {
        label: 'WorkSchedulesEmployees.management.title',
        code: 'order.workSchedules',
        faIcon: 'clock',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'WorkSchedulesManager.management.title',
            link: ['order', 'work-schedules-manager'],
          },
          {
            faIcon: 'user',
            label: 'employeesList.management.title',
            link: ['order', 'employees'],
          },
          {
            faIcon: 'file-pdf',
            label: 'Récapitulatif des soldes',
            link: ['order', 'work-schedules-recap'],
          },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          // { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
        ],
      },
      // {
      //     label: 'Configuration',
      //     faIcon: 'cog',
      //     code: 'admin.config',
      //     submenu : [
      //         { faIcon: 'users', label : 'Equipe', link : ['admin','config'] },
      //         { faIcon: 'list', label : 'Horaires', link : ['admin','config'] },
      //         { faIcon: 'calendar', label : 'Planning', link : ['admin','config'] }
      //     ]
      // },
      {
        label: 'Disconnect.label',
        faIcon: 'right-from-bracket',
        code: 'logout',
      },
    ],
  },
  {
    role: 'USER',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      {
        label: 'Site internet',
        code: 'website',
        faIcon: 'water',
        submenu: [
          {
            faIcon: 'cart-shopping',
            label: 'Paniers',
            link: ['rental', 'carts'],
          },
          {
            faIcon: 'users',
            label: 'Visiteurs moteur',
            link: ['rental', 'ea-users'],
          },
          {
            faIcon: 'robot',
            label: 'Catalogue IA',
            link: ['catalog'],
          },
          {
            faIcon: 'list-check',
            label: 'Log MCP',
            link: ['catalog', 'mcp-log'],
          },
          {
            faIcon: 'list',
            label: 'Logs Engine API (debug)',
            link: ['rental', 'be-log'],
          },

        ],
      },
      {
        label: 'Rental.management.title',
        code: 'rental',
        faIcon: 'ship',
        submenu: [
          {
            faIcon: 'envelope',
            label: 'Messages',
            link: ['rental', 'messages'],
          },
          {
            faIcon: 'calendar',
            label: 'Rental.planning.title',
            link: ['rental', 'planning'],
          },
          {
            faIcon: 'handshake-simple',
            label: 'Rental.bookingsAndOptions.label',
            link: ['rental', 'bookings'],
          },
          {
            faIcon: 'calendar-day',
            label: 'Wanday planning',
            link: ['rental', 'wanday-planning'],
          },
          {
            faIcon: 'hand-paper',
            label: 'Rental.quotes.label',
            link: ['rental', 'quotes'],
          },
          {
            faIcon: 'cloud-download-alt',
            label: 'Demandes de devis',
            link: ['rental', 'quote-requests'],
          },
          {
            faIcon: 'tags',
            label: 'Remises et optimisations',
            link: ['rental', 'optimise-discount'],
          },
          {
            faIcon: 'credit-card-alt',
            label: 'Paiements',
            link: ['rental', 'payments'],
          }
        ],
      },
      {
        label: 'Données',
        code: 'admin.data',
        faIcon: 'database',
        submenu: [
          {
            faIcon: 'toolbox',
            label: 'Equipements',
            link: ['rental', 'equipment-list'],
          },
          {
            faIcon: 'list',
            label: 'Caractéristiques (bateaux)',
            link: ['rental', 'feature-list'],
          },
          {
            faIcon: 'ship',
            label: 'Modèles de bateaux',
            link: ['rental', 'models'],
          },
          {
            faIcon: 'earth-europe',
            label: 'Régions',
            link: ['rental', 'zone-list'],
          },
          { faIcon: 'flag', label: 'Bases', link: ['rental', 'base-list'] },
          {
            faIcon: 'bridge-water',
            label: 'Voies navigables',
            link: ['rental', 'waterway-list'],
          },
          {
            faIcon: 'map-marked-alt',
            label: 'Itinéraires',
            link: ['rental', 'trip-list'],
          },
          {
            faIcon: 'ship',
            label: 'Liste des bateaux',
            link: ['rental', 'boat-list'],
          },
          {
            faIcon: 'hands-helping',
            label: 'Services et options (bateaux)',
            link: ['rental', 'boat-services-list'],
          },
          {
            faIcon: 'dollar-sign',
            label: 'Grilles de prix',
            link: ['rental', 'price-grids'],
          },
          {
            faIcon: 'envelope',
            label: 'Templates email',
            link: ['rental', 'email-templates'],
          },
        ],
      },
      {
        label: 'Ville De Digoin',
        code: 'vdd',
        faIcon: 'hotel',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'Planning',
            link: ['vdd', 'planning'],
          },
          {
            faIcon: 'handshake-simple',
            label: 'Réservations',
            link: ['vdd', 'bookings'],
          },

          {
            faIcon: 'hand-paper',
            label: 'Rental.quotes.label',
            link: ['vdd', 'quotes'],
          },
          {
            faIcon: 'ship',
            label: `Bateaux`,
            link: ['vdd', 'boats'],
          },
          {
            faIcon: 'users',
            label: `Clients`,
            link: ['vdd', 'clients'],
          },
          {
            faIcon: 'question-circle',
            label: `Type d'évènements`,
            link: ['vdd', 'trips'],
          },
          {
            faIcon: 'cube',
            label: 'Produits',
            link: ['vdd', 'items'],
          },
          {
            faIcon: 'palette',
            label: 'Catégories de produits',
            link: ['vdd', 'item-categories'],
          },
          {
            faIcon: 'tags',
            label: 'Remises',
            link: ['vdd', 'discounts'],
          },
          {
            faIcon: 'credit-card-alt',
            label: 'Paiements',
            link: ['vdd', 'payments'],
          },
          {
            faIcon: 'gift',
            label: 'Chèques cadeaux',
            link: ['vdd', 'gift-vouchers'],
          },
          {
            faIcon: 'clock-rotate-left',
            label: 'Historique',
            link: ['vdd', 'booking-history'],
          }
        ],
      },
      {
        label: 'Disconnect.label',
        faIcon: 'right-from-bracket',
        code: 'logout',
      },
    ],
  },
  {
    role: 'AGENT',
    menu: [
      {
        label: 'messaging.title',
        code: 'agents.messaging',
        faIcon: 'envelope',
        link: ['rental','agents-messaging'],
      },
      {
        label: 'Agents.bookingAndOptions.title',
        code: 'agents.bookingAndOptions',
        faIcon: 'ship',
        link: ['rental','agents-bookings-list'],
      },
      {
        label: 'Agents.bookings.title',
        code: 'agents.bookings',
        faIcon: 'handshake-simple',
        link: ['rental','agents-booking'],
      },
      {
        label: 'Disconnect.label',
        faIcon: 'right-from-bracket',
        code: 'logout',
      },
    ],
  },
  {
    role: 'OWNER',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      {
        label: 'Rental.planning.title',
        code: 'rental.planning',
        faIcon: 'calendar',
        link: ['rental', 'planning'],
      },
      {
        label: 'Rental.bookingsAndOptions.label',
        code: 'rental.bookings',
        faIcon: 'handshake-simple',
        link: ['rental', 'bookings'],
      },
      {
        label: 'Rental.quotes.label',
        code: 'rental.quotes',
        faIcon: 'hand-paper',
        link: ['rental', 'quotes'],
      },
      {
        label: 'Données',
        code: 'admin.data',
        faIcon: 'database',
        submenu: [
          { faIcon: 'user', label: 'Clients', link: ['rental', 'client-list'] },
          { faIcon: 'flag', label: 'Bases', link: ['rental', 'base-list'] },
        ],
      },
      {
        label: 'Disconnect.label',
        faIcon: 'right-from-bracket',
        code: 'logout',
      },
    ],
  },
  {
    role: 'STOCK_MANAGER',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      {
        label: 'Items.management.title',
        code: 'order.items',
        faIcon: 'cubes',
        submenu: [
          {
            faIcon: 'cube',
            label: 'Items.menu.label',
            link: ['order', 'items'],
          },
          {
            faIcon: 'people-carry',
            label: 'Supplier.menu.label',
            link: ['order', 'suppliers'],
          },
          {
            faIcon: 'square',
            label: 'Supplies.menu.label',
            link: ['order', 'supplies'],
          },
          {
            faIcon: 'th',
            label: 'Stock.menu.label',
            link: ['order', 'stocks'],
          },
        ],
      },
      {
        label: 'Orders.management.title',
        code: 'order.orders',
        faIcon: 'clipboard-list',
        submenu: [
          {
            faIcon: 'clipboard-question',
            label: 'OrderRequests.menu.label',
            link: ['order', 'order-requests'],
          },
          {
            faIcon: 'comment-dots',
            label: 'OrderRequestsCreate.menu.label',
            link: ['order', 'order-request-create'],
          },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          // { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
        ],
      },
    ],
  },
  {
    role: 'BASE_MANAGER',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      {
        label: 'Orders.management.title',
        code: 'order.orders',
        faIcon: 'clipboard-list',
        submenu: [
          {
            faIcon: 'clipboard-question',
            label: 'OrderRequestsByBase.menu.label',
            link: ['order', 'order-requests'],
          },
          {
            faIcon: 'comment-dots',
            label: 'OrderRequestsCreateByBase.menu.label',
            link: ['order', 'order-request-create'],
          },
          {
            faIcon: 'clipboard-check',
            label: 'MyOrders.menu.label',
            link: ['order', 'orders'],
          },
          // {
          //   faIcon: 'shopping-cart',
          //   label: 'SmallPurchases.menu.label',
          //   link: ['order', 'small-purchases'],
          // },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          // { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
        ],
      },
      {
        label: 'WorkSchedulesEmployees.management.title',
        code: 'order.workSchedules',
        faIcon: 'clock',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'WorkSchedulesManager.management.title',
            link: ['order', 'work-schedules-manager'],
          },
        ],
      },
      {
        label: 'Rental.management.title',
        code: 'rental',
        faIcon: 'ship',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'Rental.planning.title',
            link: ['rental', 'planning'],
          },
          // {
          //   faIcon: 'calendar-day',
          //   label: 'Wanday planning',
          //   link: ['rental', 'wanday-planning'],
          // },
        ],
      },
    ],
  },
  {
    role: 'ORDERS_MANAGER',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      // {
      //     label: 'Items.management.title',
      //     code: 'order.items',
      //     faIcon: 'cubes',
      //     submenu : [
      //         { faIcon: 'cubes', label : 'Families.items.menu.label', link : ['order','items-families'] },
      //         { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
      //         // { faIcon: 'square', label : 'Supplies.menu.label', link : ['order','supplies'] },
      //         // { faIcon: 'th', label : 'Stock.menu.label', link : ['order','stocks'] },
      //     ]
      // },
      {
        label: 'Orders.management.title',
        code: 'order.orders',
        faIcon: 'clipboard-list',
        submenu: [
          {
            faIcon: 'clipboard-question',
            label: 'OrderRequests.menu.label',
            link: ['order', 'order-requests'],
          },
          {
            faIcon: 'comment-dots',
            label: 'OrderRequestsCreate.menu.label',
            link: ['order', 'order-request-create'],
          },
          {
            faIcon: 'clipboard-check',
            label: 'Orders.menu.label',
            link: ['order', 'orders'],
          },
          // {
          //   faIcon: 'shopping-cart',
          //   label: 'SmallPurchases.menu.label',
          //   link: ['order', 'small-purchases'],
          // },
          // {
          //   faIcon: 'tags',
          //   label: 'SmallPurchaseCategories.menu.label',
          //   link: ['order', 'small-purchase-categories'],
          // },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          // { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
        ],
      },
    ],
  },
  {
    role: 'ORDERS_ADMIN',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      // {
      //     label: 'Items.management.title',
      //     code: 'order.items',
      //     faIcon: 'cubes',
      //     submenu : [
      //         { faIcon: 'cubes', label : 'Families.items.menu.label', link : ['order','items-families'] },
      //         { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
      //         // { faIcon: 'square', label : 'Supplies.menu.label', link : ['order','supplies'] },
      //         // { faIcon: 'th', label : 'Stock.menu.label', link : ['order','stocks'] },
      //     ]
      // },
      {
        label: 'Orders.management.title',
        code: 'order.orders',
        faIcon: 'clipboard-list',
        submenu: [
          {
            faIcon: 'clipboard-question',
            label: 'OrderRequests.menu.label',
            link: ['order', 'order-requests'],
          },
          {
            faIcon: 'comment-dots',
            label: 'OrderRequestsCreateByBase.menu.label',
            link: ['order', 'order-request-create'],
          },
          {
            faIcon: 'clipboard-check',
            label: 'Orders.menu.label',
            link: ['order', 'orders'],
          },
          // {
          //   faIcon: 'shopping-cart',
          //   label: 'SmallPurchases.menu.label',
          //   link: ['order', 'small-purchases'],
          // },
          // {
          //   faIcon: 'tags',
          //   label: 'SmallPurchaseCategories.menu.label',
          //   link: ['order', 'small-purchase-categories'],
          // },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          // { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
        ],
      },
      {
        label: 'WorkSchedulesEmployees.management.title',
        code: 'order.workSchedules',
        faIcon: 'clock',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'WorkSchedulesManager.management.title',
            link: ['order', 'work-schedules-manager'],
          },
          {
            faIcon: 'user',
            label: 'employeesList.management.title',
            link: ['order', 'employees'],
          },
          {
            faIcon: 'file-pdf',
            label: 'Récapitulatif des soldes',
            link: ['order', 'work-schedules-recap'],
          },
        ],
      },
      {
        label: 'Ville De Digoin',
        code: 'vdd',
        faIcon: 'hotel',
        submenu: [
          {
            faIcon: 'calendar',
            label: 'Planning',
            link: ['vdd', 'planning'],
          },
          {
            faIcon: 'handshake-simple',
            label: 'Réservations',
            link: ['vdd', 'bookings'],
          },

          {
            faIcon: 'hand-paper',
            label: 'Rental.quotes.label',
            link: ['vdd', 'quotes'],
          },
          {
            faIcon: 'ship',
            label: `Bateaux`,
            link: ['vdd', 'boats'],
          },
          {
            faIcon: 'users',
            label: `Clients`,
            link: ['vdd', 'clients'],
          },
          {
            faIcon: 'question-circle',
            label: `Type d'évènements`,
            link: ['vdd', 'trips'],
          },
          {
            faIcon: 'cube',
            label: 'Produits',
            link: ['vdd', 'items'],
          },
          {
            faIcon: 'palette',
            label: 'Catégories de produits',
            link: ['vdd', 'item-categories'],
          },
          {
            faIcon: 'tags',
            label: 'Remises',
            link: ['vdd', 'discounts'],
          },
          {
            faIcon: 'credit-card-alt',
            label: 'Paiements',
            link: ['vdd', 'payments'],
          },
          {
            faIcon: 'gift',
            label: 'Chèques cadeaux',
            link: ['vdd', 'gift-vouchers'],
          },
          {
            faIcon: 'clock-rotate-left',
            label: 'Historique',
            link: ['vdd', 'booking-history'],
          }
        ],
      },
    ],
  },
  {
    role: 'ORDERS_TECHNICIAN',
    menu: [
      {
        label: 'home.title',
        code: 'home',
        faIcon: 'home',
        link: ['/'],
      },
      // {
      //     label: 'Items.management.title',
      //     code: 'order.items',
      //     faIcon: 'cubes',
      //     submenu : [
      //         { faIcon: 'cubes', label : 'Families.items.menu.label', link : ['order','items-families'] },
      //         { faIcon: 'people-carry', label : 'Supplier.menu.label', link : ['order','suppliers'] },
      //         // { faIcon: 'square', label : 'Supplies.menu.label', link : ['order','supplies'] },
      //         // { faIcon: 'th', label : 'Stock.menu.label', link : ['order','stocks'] },
      //     ]
      // },
      {
        label: 'Orders.management.title',
        code: 'order.orders',
        faIcon: 'clipboard-list',
        submenu: [
          {
            faIcon: 'clipboard-question',
            label: 'OrderRequests.menu.label',
            link: ['order', 'order-requests'],
          },
          {
            faIcon: 'comment-dots',
            label: 'OrderRequestsCreateByBase.menu.label',
            link: ['order', 'order-request-create'],
          },
          {
            faIcon: 'clipboard-check',
            label: 'Orders.menu.label',
            link: ['order', 'orders'],
          },
          // { faIcon: 'users', label : 'GroupedOrders.menu.label', link : ['order','grouped-orders'] },
          // { faIcon: 'share-square', label : 'StockOrders.menu.label', link : ['order','stock-orders'] },
          {
            faIcon: 'people-carry',
            label: 'Supplier.menu.label',
            link: ['order', 'suppliers'],
          },
          // {
          //   faIcon: 'shopping-cart',
          //   label: 'SmallPurchases.menu.label',
          //   link: ['order', 'small-purchases'],
          // },
        ],
      },
    ],
  },
];
